/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CtiosRequestState } from './ctiosRequestState.model';
import { CtiosRequestSource } from './ctiosRequestSource.model';


export interface CtiosRequestLogDto { 
    id: number;
    persistErrors: boolean;
    requestSource: CtiosRequestSource;
    startTime: string;
    state: CtiosRequestState;
    username?: string;
}
export namespace CtiosRequestLogDto {
}


